module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address-form"
  }, [_c('div', {
    staticStyle: {
      "height": "10px"
    }
  }), _vm._v(" "), _c('van-form', [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "input-align": "right",
      "label": "申请类别",
      "placeholder": "请输入您的申请类别",
      "rules": [{
        required: true,
        message: '内容不能为空'
      }]
    },
    model: {
      value: (_vm.formData.type),
      callback: function($$v) {
        _vm.$set(_vm.formData, "type", $$v)
      },
      expression: "formData.type"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "label": "申请原因",
      "type": "textarea",
      "placeholder": "请输入您的申请原因",
      "rules": [{
        required: true,
        message: '内容不能为空'
      }]
    },
    model: {
      value: (_vm.formData.reason),
      callback: function($$v) {
        _vm.$set(_vm.formData, "reason", $$v)
      },
      expression: "formData.reason"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "label": "反馈内容",
      "type": "textarea",
      "placeholder": "请输入您的证明材料",
      "rules": [{
        required: true,
        message: '内容不能为空'
      }]
    },
    model: {
      value: (_vm.formData.content),
      callback: function($$v) {
        _vm.$set(_vm.formData, "content", $$v)
      },
      expression: "formData.content"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "uploader",
      "label": "上传图片"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('PicUploader', {
          attrs: {
            "fileList": _vm.formData.pic,
            "limit": 3,
            "name": 'pics'
          }
        })]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px",
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticClass: "save",
    attrs: {
      "round": "",
      "size": "large"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.formSave($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ad87b0c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/mine/qualifications/Qualifications.vue
// module id = 2561
// module chunks = 0